import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "relative",
  ref: "dropdown"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "absolute right-2 top-1/2 transform -translate-y-1/2",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_3 = ["checked", "onChange"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args))),
      class: "relative pr-10 pl-1 text-lg rounded-lg bg-white border-2 border-gray-600 hover:border-blue-600 focus:border-blue-600"
    }, " Kategori "),
    _hoisted_2,
    (_ctx.showDropdown)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "absolute w-full mt-1 bg-white border border-gray-400 rounded-lg shadow-lg z-10",
          style: _normalizeStyle({ width: _ctx.dropdownWidth }),
          ref: "dropdownMenu"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dropDownData, ([label, value]) => {
            return (_openBlock(), _createElementBlock("div", {
              key: label,
              class: "px-4 py-2 flex items-center dropdown-item"
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                checked: value,
                onChange: ($event: any) => (_ctx.updateCategoryFilter(label as string)),
                class: "mr-2"
              }, null, 40, _hoisted_3),
              _createTextVNode(" " + _toDisplayString(label), 1)
            ]))
          }), 128))
        ], 4))
      : _createCommentVNode("", true)
  ], 512))
}